module.exports = __webpack_public_path__ + "img/polygon.1012195a.png";